import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { ResourceBookingServiceClient } from 'store/api-client/resource-booking-service-client';
import { RootState } from 'store/reducer';

interface UseResourceBookingServiceClientValues {
  /**
   * Built lazily inside the query/mutation function rather than memoized here: the client is a thin
   * wrapper over `fetch`, and building it on demand keeps a stale token from being captured.
   */
  getClient: () => ResourceBookingServiceClient;
  buildingUuid: string | null;
  /** Needed by callers that resolve relative asset paths returned by the API. */
  apiUrl: string;
}

/**
 * Shared wiring for the resource-booking-service queries — the API url and auth token every call
 * needs, plus the building the miniapp is scoped to (which is also every query's `enabled` guard).
 */
export const useResourceBookingServiceClient = (): UseResourceBookingServiceClientValues => {
  const apiUrl = useSelector((state: RootState) => state.config.apiUrl);
  const authToken = useSelector((state: RootState) => state.config.authToken);
  const buildingUuid = useSelector((state: RootState) => state.config.buildingUuid);

  const getClient = useCallback(() => new ResourceBookingServiceClient(apiUrl, authToken), [apiUrl, authToken]);

  return { getClient, buildingUuid, apiUrl };
};
